import React from 'react';
import { Route, Switch } from 'react-router';
import TheaterList from './Theater/List';
import TheaterCreate from './Theater/Create';
import TheaterEdit from './Theater/Edit';
import ProductionList from './Production/List';
import ProductionCreate from './Production/Create';
import ProductionEdit from './Production/Edit';
import ArtistList from './Artist/List';
import CreateUser from './User/Create';
import EditUser from './User/Edit';
import UserMaintainer from './User/List';
import NewsletterList from './Newsletter/List';
import Configurations from './Configuration';
import MassiveMailer from './MassiveMailer';
import Analytics from './Analytics';

const Admin = () => (
  <Switch>
    <Route exact path="/admin/theaters" component={TheaterList} />
    <Route exact path="/admin/theater/new" component={TheaterCreate} />
    <Route exact path="/admin/theater/:theaterId" component={TheaterEdit} />

    <Route exact path="/admin/productions" component={ProductionList} />
    <Route exact path="/admin/production/new" component={ProductionCreate} />
    <Route
      exact
      path="/admin/digitalproduction/new"
      render={props => (
        <ProductionCreate {...props} isDigital />
      )}
    />
    <Route exact path="/admin/production/:productionId" component={ProductionEdit} />

    <Route exact path="/admin/artists" component={ArtistList} />

    <Route exact path="/admin/users" component={UserMaintainer} />
    <Route exact path="/admin/user/new" component={CreateUser} />
    <Route exact path="/admin/user/:userId" component={EditUser} />

    <Route exact path="/admin/mailer" component={MassiveMailer} />

    <Route exact path="/admin/newsletter" component={NewsletterList} />

    <Route exact path="/admin/configurations" component={Configurations} />

    <Route exact path="/admin/analytics" component={Analytics} />
  </Switch>
);

export default Admin;



// WEBPACK FOOTER //
// ./src/containers/Admin/index.js